import { Pipe, PipeTransform } from '@angular/core';
import {ReferenceArea} from "@/app/features/reference-areas/models/reference-area";

@Pipe({
    name: 'referenceAreaListFilterByType'
})
export class ReferenceAreaListFilterByType implements PipeTransform {

    transform(referenceAreas: ReferenceArea[], type: string): ReferenceArea[] {
        return referenceAreas && referenceAreas.filter(r => r.type === type);;
    }

}
